// extracted by mini-css-extract-plugin
export default {"contianer":"_404_contianer__LaWim","text":"_404_text__ITpL0","button":"_404_button__9k2Bi","icon":"_404_icon__iBGo7"};